<script>
import WebsiteLogo from "@/components/icons/WebsiteLogo.vue";

export default {
  name: "KeepOnRecord",
  components: {WebsiteLogo}
}
</script>

<template>
  <div class="keep-on-record">
    <div>
      <!-- <WebsiteLogo/> -->
      <img class="logo-icon" src="@/assets/logo-img.png" alt="">
      <div class="app-title">喜来健i美商学院</div>
      <div class="app-title-line"></div>
      <div class="app-b-a-label">青岛喜来健化妆品有限公司</div>
      <div class="app-b-a-label">鲁 ICP 备14019875 号-1</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.keep-on-record {
  display: flex;
  justify-content: center;

  .logo-icon{
    width: 196px;
    margin-bottom: 7px;
  }
  .app-title {
    color: #FFFFFF;
    padding: 0.5em 0;
    font-size: 14px;
  }

  .app-title-line {
    font-size: 12px;
    height: auto;
    width: 1.6em;
    margin: 20px 0;
    aspect-ratio: 9.96/2.16;
    background: #D4062E;
    border-radius: 1em;
  }

  .app-b-a-label {
    font-size: 12px;
    line-height: 25px;
  }

}
</style>
